import { TICK_DT, TICK_RATE } from '@md/shared';

export const ENGINE_NAME = 'magnetic-duo-engine';

export interface EngineInfo {
  /** Nom du moteur (affiché en pied de page du client). */
  readonly name: string;
  /** Fréquence de simulation, en Hz. */
  readonly tickRate: number;
  /** Pas de temps fixe, en secondes. */
  readonly tickDt: number;
}

/**
 * Décrit la configuration temporelle du moteur.
 *
 * Sert de point d'entrée minimal en phase 0 : prouve le câblage
 * `shared ← engine` et sera conservé comme information de diagnostic.
 */
export function describeEngine(): EngineInfo {
  return { name: ENGINE_NAME, tickRate: TICK_RATE, tickDt: TICK_DT };
}
